import React from 'react'
import { useIntl } from 'react-intl'

import './SearchInput.sass'

interface SearchInputProps {
  value: string
  onChange: (newValue: string) => void
}

const SearchInput = ({ value, onChange }: SearchInputProps) => {
  const intl = useIntl()
  return (
    <label className="search-input">
      <input
        type="search"
        name="search"
        placeholder={intl.formatMessage({ id: 'placeholder.search' })}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <span className="icon icon-search" />
    </label>
  )
}

export default SearchInput
